import axios from 'axios';
import { CreatePdfReportRequest } from '../common/model/dto/pdf-report/create-pdf-report-request';
import { API_PATH_PREFIX, CLINIC_LOCATION_ROUTE } from '../api/backend';
import { UpdatePdfReportRequest } from '../common/model/dto/pdf-report/update-pdf-report-request';
import { PdfReport } from '../common/model/dto/pdf-report';
import { Paginated } from '../common/types';

export const getPdfReportsForPatient = async (
  clinicLocationId: string,
  patientId: string,
  query: string
) => {
  const { data } = await axios.get<Paginated<PdfReport>>(
    `${CLINIC_LOCATION_ROUTE}/${clinicLocationId}/patients/${patientId}/pdf-reports?${query}`
  );

  return data;
};

export const createPdfReportForPatient = async (
  clinicLocationId: string,
  patientId: string,
  createPdfReportRequest: CreatePdfReportRequest
) => {
  return await axios.post(
    `pdf-reports/clinic-locations/${clinicLocationId}/patients/${patientId}`,
    createPdfReportRequest,
    {
      baseURL: `${process.env.REACT_APP_FILE_SERVICE_URL}${API_PATH_PREFIX}`,
    }
  );
};

export const updatePdfReportForPatient = async (
  clinicLocationId: string,
  patientId: string,
  pdfReportId: string,
  updatePdfReportRequest: UpdatePdfReportRequest
) => {
  return await axios.patch(
    `${CLINIC_LOCATION_ROUTE}/${clinicLocationId}/patients/${patientId}/pdf-reports/${pdfReportId}`,
    updatePdfReportRequest
  );
};

export const deletePdfReportForPatient = async (
  clinicLocationId: string,
  patientId: string,
  pdfReportId: string
) => {
  return await axios.delete(
    `${CLINIC_LOCATION_ROUTE}/${clinicLocationId}/patients/${patientId}/pdf-reports/${pdfReportId}`
  );
};
